import React, {useContext} from 'react';
import styled from 'styled-components'
import {getTheme} from "../shared/themeUtils";
import {ClientContext} from "../contexts/ClientContext";

const WebInfoContainer = styled.div`
    color: ${getTheme("colors.accent")};
    background: ${getTheme("colors.accentLight")};
    text-align: center;
    padding: ${getTheme("space.1")};
`

export default function WebInfo() {
    const {clientCtx} = useContext(ClientContext);

    return (
        <WebInfoContainer>
            {clientCtx?.webInfoBanners && clientCtx.webInfoBanners[0].text}
        </WebInfoContainer>
    )
}

